<template>
  <section class="cookie-policy">
    <div class="container">
      <div class="cookie-policy__wrapper col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
        <div class="row push-v--desktop--large push-v--tablet--large push-v--mobile--x-small">
          <div class="col-12 col-md-6 text-center--mobile">
            <h1 class="cookie-policy__title push-v--mobile--x-small">{{ title }}</h1>
          </div>
          <div v-if="date" class="col-12 col-md-6 text-right--desktop text-right--tablet text-center--mobile">
            <p class="cookie-policy__date text--faux push-v--mobile--small">{{ date }}</p>
          </div>
        </div>
        <div v-if="body" class="cookie-policy__body" v-html="body" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: { type: String, default: 'Cookie Policy', required: true },
    date: { type: String, default: 'Valid as of 25 May 2018', required: true },
    body: { type: String, default: '', required: true },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_cookie-policy.scss';
</style>
